module.exports = __webpack_public_path__ + "img/museum-of-ethnography.73401e2.svg";